// src/components/Hero.js
import React from "react";

const Hero = () => {
  const containerStyle = {
    backgroundImage: "url('./banner_desktop.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    padding: "60px 0",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center"
  };

  const glossyCardStyle = {
    background: "linear-gradient(135deg, rgba(255,255,255,0.2), rgba(255,255,255,0.1))",
    borderRadius: "16px",
    padding: "35px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
    backdropFilter: "blur(12px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    color: "white",
    width: "100%",
    marginTop: "-20px",
    position: "relative",
    overflow: "hidden"
  };

  // Add a subtle gradient overlay for better glass effect
  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(135deg, rgba(139, 21, 27, 0.05) 0%, rgba(5, 24, 49, 0.05) 100%)",
    zIndex: -1
  };

  const benefitItemStyle = {
    fontSize: "1rem",
    fontWeight: 500,
    color: "rgba(1, 14, 32, 0.9)",
    marginBottom: "18px",
    display: "flex",
    alignItems: "center",
    gap: "12px"
  };

  // SVG Icons for each benefit
  const svgIcons = {
    digital: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7 10L12 15L17 10" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 15V3" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    rates: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    amount: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1V23" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    repayment: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 8V12L15 15" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    service: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 12H7L10 8L14 16L17 12H21" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    tenure: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2V2Z" stroke="#8B151B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  };

  return (
    <div style={containerStyle}>
      <div className="container">
        {/* HERO ROW */}
        <div className="row align-items-center">
          {/* LEFT COL */}
          <div className="col-lg-7 mb-4 mb-lg-0">
            <h1 style={{ color: "#051831", fontWeight: 700, fontSize: "2rem", marginBottom: "20px" }}>
              The Smart Way to Fuel your Ambitions: <span style={{ color: "#8B151B"}}>aditya birla finance capital</span> 
            </h1>
            <p style={{ color: "#5c5b5b", fontSize: "1.2rem", lineHeight: "1.6" }}>
              Get funds via your property as collateral. Quick registration, minimal documentation, 
              and fast loan disbursal with ABFC's aditya birla finance capital.
            </p>
          </div>

          {/* RIGHT COL */}
          <div className="col-lg-5 text-center">
            <img 
              src="./banner.png" 
              alt="aditya birla finance capital" 
              style={{ 
                maxWidth: "100%", 
                borderRadius: "12px",
                
              }} 
            />
          </div>
        </div>

        {/* GLOSSY CARD BELOW */}
        <div style={glossyCardStyle}>
          <div style={overlayStyle}></div>
          <h3 style={{ color: "#8B151B", fontWeight: 700, marginBottom: "25px", textAlign: "left" }}>
            Key Benefits
          </h3>

          {/* Row 1 */}
          <div className="row">
            <div className="col-md-6">
              <div style={benefitItemStyle}>
                {svgIcons.digital}
                Digital Onboarding & Quick Sanctions
              </div>
            </div>
            <div className="col-md-6">
              <div style={benefitItemStyle}>
                {svgIcons.rates}
                Attractive Interest Rates
              </div>
            </div>
          </div>

          {/* Row 2 */}
          <div className="row">
            <div className="col-md-6">
              <div style={benefitItemStyle}>
                {svgIcons.amount}
                Wide Loan Amount Range
              </div>
            </div>
            <div className="col-md-6">
              <div style={benefitItemStyle}>
                {svgIcons.repayment}
                Flexible Repayment period
              </div>
            </div>
          </div>

          {/* Row 3 */}
          <div className="row">
            <div className="col-md-6">
              <div style={benefitItemStyle}>
                {svgIcons.service}
                Doorstep service by dedicated Relationship Manager
              </div>
            </div>
            <div className="col-md-6">
              <div style={benefitItemStyle}>
                {svgIcons.tenure}
                Loan Tenure of up to 20 Years
              </div>
            </div>
            
          </div>
        
        </div>
         <div style={{color: 'red', fontSize: '12px', padding: '15px', fontWeight: 'bold'}}>T&C Applied </div>
      </div>
    </div>
  );
};

export default Hero;